function handleMilestones() {
    $('.milestone').wrapAll('<div class="milestone-slider slick-dotted" />');
    $('.milestone-slider').slick({
        dots: true,
        arrows: true,
        infinite: false,
        autoplay: false,
        centerMode: true,
        centerPadding: 'calc(50% - 250px)',
        prevArrow: '<button type="button" class="slick-arrow prev-arrow"><span class="sr-only">Back</span><i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-arrow next-arrow"><span class="sr-only">Next</span><i class="fa-solid fa-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 1070,
                settings: {
                    centerPadding: '300px'
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    centerPadding: 0
                }
            }
        ]
    });

}


$(function(){
    handleMilestones();
});